import React, { Component } from 'react'
import './Members.css'
import { database, ref, query, orderByChild, startAt, endAt, limitToFirst, get } from '../../firebase'

class Members extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: '',
      results: []
    }
    this.handleSearch = this.handleSearch.bind(this)
  }
  handleSearch (ev) {
    const value = ev.target.value.replace(/\b\w/g, l => l.toUpperCase())
    this.setState({
      term: value
    })
    if (value !== '') {
      const usersRef = ref(database, 'usuarios/index')
      const q = query(usersRef, orderByChild('name'), startAt(value), endAt(value + '\uf8ff'), limitToFirst(5))
      get(q)
        .then((snap) => {
          if (snap.val()) {
            const results = []
            snap.forEach((child) => {
              results.push({
                id: child.key,
                name: child.val().name,
                photo: child.val().photo
              })
            })
            this.setState({
              results: results.filter((result) => result.id !== this.props.admin.id)
            })
          } else {
            this.setState({
              users: []
            })
          }
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      this.setState({
        results: []
      })
    }
  }
  selectMember (selected) {
    const currentMembers = this.props.members
    if (!currentMembers.some((member) => {
      return member.id === selected.id
    })) {
      currentMembers.push(selected)
      this.props.handleMembers(currentMembers)
    }
  }
  removeMember (selected) {
    const newMembers = this.props.members.filter((member) => member.id !== selected)
    this.props.handleMembers(newMembers)
  }
  render () {
    return (
      <div className='members'>
        <div className='members__label'>Participantes</div>
        <div className='members__selected'>
          {this.props.members.map((member) => <Selected {...member} key={member.id} onClick={() => this.removeMember(member.id)} />)}
        </div>
        <input
          className={this.state.error ? 'members__search members__search--error' : 'members__search'}
          type='search'
          value={this.state.term}
          placeholder='Busca por el nombre'
          onChange={this.handleSearch}
        />
        <div className='members__result'>
          {this.state.results.map((result) => <Result {...result} key={result.id} onClick={() => this.selectMember(result)} />)}
        </div>
      </div>
    )
  }
}

const Selected = (props) => (
  <div className='members__selected__row'>
    <div className='members__selected__image'>
      <img src={props.photo} alt={props.name} />
    </div>
    <div className='members__selected__name'>{props.name.length > 14 ? props.name.substring(0, 14) + '...' : props.name}</div>
    <div className='members__selected__remove' onClick={() => { props.onClick() }}>
      <i className='material-icons'>close</i>
    </div>
  </div>
)

const Result = (props) => (
  <div className='members__result__row' onClick={() => { props.onClick() }}>
    <div className='members__result__image'>
      <img src={props.photo} alt={props.name} />
    </div>
    <div className='members__result__info'>
      <div className='members__result__name'>{props.name.length > 24 ? props.name.substring(0, 24) + '...' : props.name}</div>
    </div>
  </div>
)

export default Members
